const setActiveFaceplateOption = (material) => {
    return {
        type: 'SET_ACTIVE_FACEPLATE_OPTION',
        payload: material
    };
};

const setLeftFaceplateOption = (material) => {
    return {
        type: 'SET_LEFT_FACEPLATE_OPTION',
        payload: material
    };
};

const setRightFaceplateOption = (material) => {
    return {
        type: 'SET_RIGHT_FACEPLATE_OPTION',
        payload: material
    };
};

const setActiveFaceplateType = (type) => {
    return {
        type: 'SET_ACTIVE_FACEPLATE_TYPE',
        payload: type
    };
};
// eslint-disable-next-line
export default {
    setActiveFaceplateOption,
    setActiveFaceplateType,
    setLeftFaceplateOption,
    setRightFaceplateOption
};
